module.exports = __webpack_public_path__ + "img/mobile_app_banner_mobile_en.75a0f9c4.png";